import React from 'react'
import { FormattedMessage } from 'react-intl'
import styled from 'styled-components'
import { calculateRate, Fraction } from '../../types/Fees'
import Amount from '../Amount'

const Row = styled.div`
  display: flex;
  align-items: center;
`

const TaxName = styled.div`
  padding-left: 8px;
  flex: 111;
`

const TaxAmount = styled.div`
  padding-left: 8px;
  flex: 108;
`

const TaxAction = styled.div`
  display: flex;
  justify-content: flex-end;
  flex: 104;
`

type Props = {
  name: string
  rate: Fraction
  total?: number
  unit?: string
  actions?: React.ReactNode
}

const TaxRow = ({ name, rate, total, unit, actions }: Props) => (
  <Row>
    <TaxName>{name}</TaxName>
    <TaxAmount>
      {!!total && !!unit ? (
        <Amount amount={calculateRate(rate, total)} unit={unit} />
      ) : (
        <FormattedMessage id="notApplicable" />
      )}
    </TaxAmount>
    <TaxAction>{actions}</TaxAction>
  </Row>
)

export default TaxRow
